import { render, staticRenderFns } from "./SuscripcionCortas.vue?vue&type=template&id=64f37141&scoped=true&"
import script from "./SuscripcionCortas.vue?vue&type=script&lang=js&"
export * from "./SuscripcionCortas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f37141",
  null
  
)

export default component.exports